import { useEffect } from "react";
import config from "../config/config.json";

export function useDocumentTitle(
  title: string,
  { noSuffix }: { noSuffix?: boolean } = {},
) {
  useEffect(() => {
    const pageTitle = !!noSuffix ? title : `${title} - ${config.appName}`;
    document.title = pageTitle;
  }, [title, noSuffix]);
}
